export const toUpperFirst = (string: string): string => string && string.charAt(0).toUpperCase() + string.slice(1);

export const snakeToCamel = (snake_case: string): string =>
  snake_case.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
